import workflowHistories from "./workflowHistories";
import registrations from "../inbox/registrationInboxes";

const workflowService = [
    {
        matcher:'workflows/histories',
        reply: config => {
            return [200, workflowHistories];
        }
    },
    {
        matcher: /workflows\/histories\/(.*)/,
        reply: config => {
            const no = /workflows\/histories\/(.*)/.exec(config.url)[1];
            const history = workflowHistories.find(data => data.no === no);
            return [200, history];
        }
    }
]

export default  workflowService;